import {
  ChecklistTemplate,
  ChecklistTemplateEntry,
  getUncheckedChecklistModules,
  isChecklistModule,
  isModuleChecked,
} from '@/utils/checked-modules.util';
import { CheckpointCheck, InspectionCheckpointCheckResult } from '@/types/CheckpointCheck.type';
import { hasNestedCheckpointChecks, isCheckpointComplete } from '@/utils/checkpoint-checks.util';

export interface ChecklistValidationResult {
  isValid: boolean;
  errorKey?: 'module_checklist_required' | 'inspection_checklist_incomplete';
  uncheckedModules?: Array<{ moduleName: string; header: string }>;
}

export function validateModuleChecklistSave(params: {
  moduleStructure: ChecklistTemplateEntry | undefined;
  moduleName: string | undefined;
  checkedModules: string | undefined;
  isMandatoryModuleCheckEnabled?: boolean;
  checkpointChecks?: ReadonlyArray<CheckpointCheck>;
  checkpointCheckResults?: ReadonlyArray<InspectionCheckpointCheckResult>;
  templateId?: string;
}): ChecklistValidationResult {
  if (!params.isMandatoryModuleCheckEnabled) {
    return { isValid: true };
  }
  const { moduleStructure, moduleName, checkedModules } = params;
  if (!moduleStructure || !moduleName || !isChecklistModule(moduleStructure)) {
    return { isValid: true };
  }
  if (hasNestedCheckpointChecks(params.checkpointChecks ?? [], params.templateId, moduleName)) {
    if (
      isCheckpointComplete({
        checks: params.checkpointChecks ?? [],
        results: params.checkpointCheckResults,
        templateId: params.templateId,
        checkpointCode: moduleName,
      })
    ) {
      return { isValid: true };
    }
    return { isValid: false, errorKey: 'module_checklist_required' };
  }
  if (isModuleChecked(checkedModules, moduleName)) {
    return { isValid: true };
  }
  return { isValid: false, errorKey: 'module_checklist_required' };
}

export function validateInspectionChecklistSubmit(params: {
  template: ChecklistTemplate | null | undefined;
  checkedModules: string | undefined;
  isMandatoryModuleCheckEnabled?: boolean;
  checkpointChecks?: ReadonlyArray<CheckpointCheck>;
  checkpointCheckResults?: ReadonlyArray<InspectionCheckpointCheckResult>;
  templateId?: string;
}): ChecklistValidationResult {
  if (!params.isMandatoryModuleCheckEnabled) {
    return { isValid: true };
  }
  const uncheckedModules = getUncheckedChecklistModules(params.template, params.checkedModules, {
    checks: params.checkpointChecks ?? [],
    results: params.checkpointCheckResults,
    templateId: params.templateId,
  });
  if (uncheckedModules.length === 0) {
    return { isValid: true };
  }
  return {
    isValid: false,
    errorKey: 'inspection_checklist_incomplete',
    uncheckedModules,
  };
}
